import React, { useEffect, useMemo } from "react";
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Box,
  Pagination,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import UpdateBusinessGroup from "./UpdateBusinessGroup";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
// import { selectgroupss } from '../../redux/businessSlice';
import { useSelector } from "react-redux";
// import { selectgroups } from '../../redux/businessSlice';
import { selectgroups } from "../../redux/businessSlice";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import { toast } from "react-toastify";
import { deletegroup } from "../../redux/businessSlice";
import { useDispatch } from "react-redux";
import LoadingOverlay from "../../mui/LoadingOverlay";
import WarningModal from "../WarningModal";
import { orgwarndata } from "../../redux/websocketSlice";
import { selectAdmin, selectDevice } from "../../redux/adminSlice";
import { useDeleteGroupMutation } from "../../redux/organizationApi";
const GroupBusinesses = () => {
  const deviceId = useSelector(selectDevice);
  const businesses = useSelector(selectgroups);
    const admin = useSelector(selectAdmin);
  
  // console.log("businesses", businesses);
  const warndata = useSelector(orgwarndata);
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [open, setOpen] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [iddata, setIddata] = useState("");
  const [openupdate, setUpdate] = useState(false);
  const [group, setGroup] = useState();
  const [deleteGroupMutation, { isLoading: isDeletingGroup }] = useDeleteGroupMutation();
  const [warningOpen, setWarningOpen] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    if (Array.isArray(businesses)) {
      setInitialLoading(false);
    }
  }, [businesses]);

  // Calculate pagination
  const paginatedBusinesses = useMemo(() => {
    if (!Array.isArray(businesses)) return [];
    const startIndex = (page - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return businesses.slice(startIndex, endIndex);
  }, [businesses, page, rowsPerPage]);

  const totalPages = useMemo(() => {
    if (!Array.isArray(businesses)) return 0;
    return Math.ceil(businesses.length / rowsPerPage);
  }, [businesses, rowsPerPage]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1); // Reset to first page when changing rows per page
  };

  const handleDeleteClick = (business) => {
    if (business.organizationCount > 0) {
      setWarningMessage(`Cannot delete "${business.businessNature}" business group. It has ${business.organizationCount} organisation(s) associated with it. Please remove all organisations first.`);
      setWarningOpen(true);
    } else {
      setIddata(business._id);
      setName(business.businessNature);
      setOpen(true);
    }
  };

  const onConfirm = async () => {
    setOpen(false);
    try {
      await deleteGroupMutation(iddata).unwrap();
      dispatch(deletegroup(iddata));
      toast.success("Business group deleted successfully");
      // Reset to first page if current page becomes empty after deletion
      if (paginatedBusinesses.length === 1 && page > 1) {
        setPage(page - 1);
      }
    } catch (error) {
      toast.error(
        error?.data?.message || error?.error || "Failed to delete group"
      );
    }
  };
  const navigate = useNavigate();
  //   const businesses = [
  //     { id: 1, businessNature: 'Retail', businessColor: '#FF5733' },
  //     { id: 2, businessNature: 'Manufacturing', businessColor: '#33FF57' },
  //     { id: 3, businessNature: 'Services', businessColor: '#3357FF' },
  //   ];

  if (initialLoading) {
    return (
      <Paper style={{ padding: "20px" }}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress />
        </Box>
      </Paper>
    );
  }

  return (
    <Paper style={{ padding: "20px" }}>
      <h4 style={{ float: "left", marginBottom: "20px" }}> Business Groups</h4>
      <Button
        variant="contained"
        color="primary"
        style={{ float: "right", marginBottom: "20px" }}
        onClick={() => {
          navigate("/admin/Createbusinessgroup");
        }}
      >
        + Add Business Group
      </Button>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className="fw-bold">Business Group</TableCell>
            <TableCell className="text-center fw-bold">
              {" "}
              Business Color
            </TableCell>
            <TableCell className="text-center fw-bold">Organisation Count</TableCell>
            <TableCell className="fw-bold">Edit</TableCell>
            <TableCell className='fw-bold'>Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {paginatedBusinesses.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} align="center" sx={{ padding: "40px" }}>
                <Typography variant="body2" color="text.secondary">
                  No business groups found
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            paginatedBusinesses.map((business) => (
            <TableRow key={business._id}>
              <TableCell sx={{ textTransform: "capitalize" }}>
                {business.businessNature}
              </TableCell>
              <TableCell>
                <div
                  className="mx-auto"
                  style={{
                    backgroundColor: business.businessColor,
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    alignItems: "center",
                    boxShadow: "0 0 6px rgba(0,0,0,0.3)",
                  }}
                ></div>
              </TableCell>
              <TableCell className="text-center">
                <span style={{ 
                  backgroundColor: business.organizationCount > 0 ? '#e3f2fd' : '#f5f5f5',
                  padding: '4px 8px',
                  borderRadius: '12px',
                  fontSize: '14px',
                  fontWeight: business.organizationCount > 0 ? 'bold' : 'normal',
                  color: business.organizationCount > 0 ? '#1976d2' : '#666'
                }}>
                  {business.organizationCount || 0}
                </span>
              </TableCell>
              <TableCell>
                <IconButton
                  color="primary"
                  onClick={() => {
                    setGroup(business);
                    setUpdate(true);
                    dispatch({
                      type: "alertchange", payload: {
                        id: business?._id,
                        message: "Another users also edit this business group"
                      }
                    })
                  }}
                >
                  <EditIcon />
                </IconButton>
              </TableCell>
              <TableCell>
                <IconButton color="primary" onClick={() => handleDeleteClick(business)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      
      {/* Pagination Controls */}
      {Array.isArray(businesses) && businesses.length > 0 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "20px",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Showing {((page - 1) * rowsPerPage) + 1} to {Math.min(page * rowsPerPage, businesses.length)} of {businesses.length} business groups
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography variant="body2" color="text.secondary">
              Rows per page:
            </Typography>
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              style={{
                padding: "4px 8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              color="primary"
              showFirstButton
              showLastButton
            />
          </Box>
        </Box>
      )}
      <DeleteConfirmationModal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        onConfirm={onConfirm}
        groupName={name}
      />
      <UpdateBusinessGroup
        open={openupdate}
        onClose={() => {
          setUpdate(false);
          dispatch({
            type: "alertremove", payload: {
              id: group?._id,
              message: "Another users also edit this business group"
            }
          })
        }}

        group={group}
      />
      {(openupdate && group?._id === warndata?.objId && warndata?.users?.filter((item) => item !== admin?._id + "-" + deviceId).length > 0) && <WarningModal setOpen={setUpdate} setNodeData={setGroup} users={warndata?.users}  usersInfo={warndata?.usersInfo || []} nodeId={warndata?.objId} />}

      {/* Warning Modal for organization count */}
      <DeleteConfirmationModal
        open={warningOpen}
        onClose={() => setWarningOpen(false)}
        onConfirm={() => setWarningOpen(false)}
        groupName="Warning"
        customMessage={warningMessage}
        isWarning={true}
      />

      <LoadingOverlay open={isDeletingGroup} />
    </Paper>
  );
};

export default GroupBusinesses;
